export const weatherIconMap: Record<number, string> = {
	0: 'clear_day',
	1: 'clear_day',
	2: 'partly_cloudy_day',
	3: 'cloud',
	45: 'foggy',
	48: 'mist',
	51: 'rainy_light',
	53: 'rainy_light',
	55: 'rainy_light',
	56: 'rainy_snow',
	57: 'rainy_snow',
	61: 'rainy_light',
	63: 'rainy',
	65: 'rainy_heavy',
	66: 'rainy_snow',
	67: 'rainy_snow',
	71: 'snowing',
	73: 'snowing',
	75: 'weather_snowy',
	77: 'weather_snowy',
	80: 'rainy_light',
	81: 'rainy',
	82: 'rainy_heavy',
	85: 'snowing',
	86: 'weather_snowy',
	95: 'thunderstorm',
	96: 'weather_hail',
	99: 'weather_hail'
};

export const weatherLabelMap: Record<number, string> = {
	0: 'Clear',
	1: 'Mainly Clear',
	2: 'Partly Cloudy',
	3: 'Overcast',
	45: 'Fog',
	48: 'Mist',
	51: 'Light Drizzle',
	53: 'Drizzle',
	55: 'Heavy Drizzle',
	56: 'Light Freezing Drizzle',
	57: 'Freezing Drizzle',
	61: 'Light Rain',
	63: 'Rain',
	65: 'Heavy Rain',
	66: 'Light Freezing Rain',
	67: 'Freezing Rain',
	71: 'Light Snow',
	73: 'Snow',
	75: 'Heavy Snow',
	77: 'Snow Grains',
	80: 'Light Showers',
	81: 'Showers',
	82: 'Heavy Showers',
	85: 'Snow Showers',
	86: 'Heavy Snow Showers',
	95: 'Thunderstorm',
	96: 'Thunderstorm (Hail)',
	99: 'Heavy Thunderstorm'
};
